<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" :key="error" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      <div :class="{'has-error':errors.aFormFieldsetExportTag}">
        <label>Select a field to get data from:</label>
        <select :value="aFormFieldsetExportTag" name="aFormFieldsetExportTag" class="form-control" @change="handleChange">
          <template v-for="fieldset in config.sourceFieldsets">
            <option v-if="fieldset.label != ''" :key="fieldset.export_tag" :value="fieldset.export_tag">
              {{ fieldset.label }}
            </option>
          </template>
        </select>
      </div>
      <div :class="{'has-error':errors.targetDeviceId}">
        <label>Select a data source to populate with data:</label>
        <select :value="targetDeviceId" name="targetDeviceId" class="form-control" @change="handleChange">
          <template v-for="source in config.deviceSources">
            <option v-if="source.id != config.sourceId" :key="source.id" :value="source.id">
              {{ source.name }}
            </option>
          </template>
        </select>
      </div>
      <div :class="{'has-error':errors.configField}">
        <label>Enter a field name where the data will be stored:</label>
        <input :value="configField" name="configField" class="form-control" @change="handleChange">
      </div>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    
    props: {
      aFormFieldsetExportTag: String,
      targetDeviceId: String,
      configField: String,
      id: String,
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.aFormFieldsetExportTag) {
          this.errors.aFormFieldsetExportTag = "Please select a field to get data from.";
        }

        if (!this.isNumber(this.targetDeviceId)) {
          this.errors.targetDeviceId = "Please select a device to populate with data.";
        }

        if (!this.configField) {
          this.errors.configField = "Please enter a field name.";
        }
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
